import gql from 'graphql-tag';
import { DirectoryFragments } from './directory.fragments';

export class DirectoryMutations {
  static createDirectoryMutation = gql`
    mutation CreateResourceDirectory($payload: CreateResourceDirectoryInput!) {
      createResourceDirectory(payload: $payload) {
        ...directoryFragment
      }
    }
    ${DirectoryFragments.directoryFragment}
  `;

  static updateDirectoryMutation = gql`
    mutation UpdateResourceDirectory($payload: UpdateResourceDirectoryInput!) {
      updateResourceDirectory(payload: $payload) {
        ...directoryFragment
      }
    }
    ${DirectoryFragments.directoryFragment}
  `;

  static deleteDirectoryMutation = gql`
    mutation DeleteResourceDirectory($id: String!) {
      deleteResourceDirectory(id: $id)
    }
  `;
}
